module.exports = __webpack_public_path__ + "static/media/inovacao.46a46bce.jpg";